// Styles
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";
import typography from "assets/theme/base/typography";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { lg } = boxShadows;
const { size } = typography;
const { borderRadius } = borders;

export default {
  defaultProps: {
    disableAutoFocusItem: true,
  },

  styleOverrides: {
    paper: ({ theme }) => ({
      minWidth: pxToRem(160),
      boxShadow:
        theme.palette.mode === "dark"
          ? "0 4px 20px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.08)"
          : lg,
      padding: `${pxToRem(16)} ${pxToRem(8)}`,
      fontSize: size.sm,
      color: theme.palette.text.primary,
      textAlign: "left",
      backgroundColor: `${theme.palette.background.paper} !important`,
      borderRadius: borderRadius.md,
    }),
  },
};
